import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=0512de78&scoped=true"
import script from "./Tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=0512de78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512de78",
  null
  
)

export default component.exports